exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container{\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    z-index: 10;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(233, 230, 230, 0.514);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.model-wapper{\n    background: #ffffff;\n    border-radius: 4px;\n    padding: 16px;\n}", ""]);

// exports
